import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { useAppSelector } from "flavours/glitch/store";

const ThemeComponent = ({ children }) => {
  const theme = useAppSelector(
    (state) => state.getIn(["local_settings", "theme"]) ?? "mastodon-light",
  );

  const SwipeNav = useAppSelector(
    (state) => state.getIn(["local_settings", "swipe_nav"]) ?? false,
  );

  const WellBeing = useAppSelector(
    (state) => state.getIn(["local_settings", "wellbeing"]) ?? false,
  );

  useEffect(() => {
    if (SwipeNav) {
      document.body.classList.add('swipe_nav_enabled');
    } else {
      document.body.classList.remove('swipe_nav_enabled');
    }
  }, [SwipeNav]);

  useEffect(() => {
    if (WellBeing) {
      document.body.classList.add('wellbeing_enabled');
    } else {
      document.body.classList.remove('wellbeing_enabled');
    }
  }, [WellBeing]);

  let href;
  switch (true) {
    case theme === "mastodon":
      href = "";
      break;
    case theme === "mastodon-light":
      href = "/packs/css/skins/glitch/mastodon-light/common.css";
      break;
    case theme === "dark":
      href = "/packs/css/skins/glitch/dark/common.css";
      break;
    case theme === "contrast":
      href = "/packs/css/skins/glitch/contrast/common.css";
      break;
  }

  return (
    <>
      {href !== "" ? <link rel='stylesheet' media='all' href={href} /> : null}
      {children}
    </>
  );
};

ThemeComponent.propTypes = {
  children: PropTypes.node,
};

export { ThemeComponent };
